import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { BackButton } from "../../../../components/primaryComponents";
import { BulkExpenseForm } from "../../../../components/secondaryComponents/Expenses";

export const CreateBulkExpense = () => {
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Bulk Expense"
      description="Create bulk expenses"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles?.pageColumnGaps}`}
        >
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <BackButton />
            <h4 className="mb-0">Create Bulk Expense</h4>
          </div>

          <BulkExpenseForm />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
